export default __webpack_public_path__ + "static/media/screws_imagetag.92edf1f4.jpg";